export default "__VITE_ASSET__D5gZ_KA1__"